import useImmutableSWR from 'swr/immutable';
import type {SWRResponse} from 'swr';
import {CACHE_KEY} from './key';
import type {SinglePlaylistRowQuery} from '@app/modules/graphql/generated';

export function useArtistremunerationData(): SWRResponse<SinglePlaylistRowQuery> {
	// This hook is only used to return the cached value, returns null otherwise
	return useImmutableSWR(CACHE_KEY, null);
}
